<div
  class="form-group"
>
  <label>
    Válassz fájlt
    <input type="file"    
      id="file"
      (change)="handleFileInput($event.target.files)"
      accept="image/*"
    >
  </label>
  <div class="file" *ngIf="fileToUpload !== null">{{fileToUpload.name}}</div>
  <app-button (click)="uploadFile()" [title]="'Feltöltés'"></app-button>
</div>
